import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts, getAllProductsSearch } from '../../redux/actions/productsAction';
import { getAllProductsPage } from './../../redux/actions/productsAction';

const ViewSearchProductsHook = () => {
    let limit = 3,
        sortType = "",
        sort,
        items = [],
        pagination = [],
        results = 0,
        pricefromString = "", priceToString = "",
        word = "", queryCat = "", brandCat = "", priceTo = "", priceFrom = "";

    const dispatch = useDispatch();



    const allProducts = useSelector((state) => state.allproducts.allProducts)
    // set data in items
    try {
        if (allProducts.data) {
            items = allProducts.data;
        }
        else
            items = []
    } catch (e) { }
    // set page in pagination
    try {
        if (allProducts.pages) {
            pagination = allProducts.pages.numberOfPages;
        }
        else
            pagination = []
    } catch (e) { }


    try {
        if (allProducts.results)
            results = allProducts.results;
        else
            results = 0
    } catch (e) { }

    //when click pagination
    const onPress = async (page) => {
        getStorge();
        sortData();
        // &keyword=${word}
        await dispatch(getAllProductsSearch(`sort=${sort}&limit=${limit}&page=${page}&${queryCat}&${brandCat}${pricefromString}${priceToString}`))
    }
    const getStorge = () => {
        if (localStorage.getItem("searchWord") != null) {
            word = localStorage.getItem("searchWord")
        }
        if (localStorage.getItem("catCecked") != null) {
            queryCat = localStorage.getItem("catCecked")
        }
        if (localStorage.getItem("brandCecked") != null) {
            brandCat = localStorage.getItem("brandCecked")
        }
        if (localStorage.getItem("priceTo") != null) {
            priceTo = localStorage.getItem("priceTo")
        }
        if (localStorage.getItem("priceFrom") != null) {
            priceFrom = localStorage.getItem("priceFrom")
        }

        if (priceFrom === "" || priceFrom <= 0) {
            pricefromString = ""
        } else {
            pricefromString = `&price[gt]=${priceFrom}`
        }

        if (priceTo === "" || priceTo <= 0) {
            priceToString = ""
        } else {
            priceToString = `&price[lte]=${priceTo}`
        }
    }

    ///when user choose sort type
    const sortData = () => {
        if (localStorage.getItem("sortType") !== null) {
            sortType = localStorage.getItem("sortType")
        } else {
            sortType = "";
        }
        if (sortType === "السعر من الاقل للاعلي")
            sort = "price"
        else if (sortType === "السعر من الاعلي للاقل")
            sort = "-price"
        else if (sortType === "")
            sort = ""
        else if (sortType === "الاكثر مبيعا")
            sort = "-sold"
        else if (sortType === "الاعلي تقييما")
            sort = "-quantity"
    }

    const getProduct = async () => {
        getStorge();
        sortData();
        // &keyword=${word}
        await dispatch(getAllProductsSearch(`sort=${sort}&limit=${limit}&${queryCat}&${brandCat}${pricefromString}${priceToString}`))
    }
    useEffect(() => {
        getProduct()
    }, [])

    return [items, pagination, onPress, getProduct, results]

}

export default ViewSearchProductsHook